import ExpectationsSectionBottomContent from "./bottom-content";
import ExpectationSectionMidContent from "./mid-content";

const ExpectationsSection = () => {
  return (
    <section className="px-8 py-16 md:px-0 md:py-12 lg:py-24 flex flex-col 
      space-y-8 md:space-y-12 lg:space-y-24">
      <ExpectationSectionMidContent />
      <ExpectationsSectionBottomContent />
    </section>
  )
};

export default ExpectationsSection;
